import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Breadcrumb, FrontPagination } from '@shared/components';
import { NgGenerateTableColumns } from 'ng-generate-table';
import { Router } from '@angular/router';
import { NgBsModalService } from 'ng-bs-modal-service';
import { NgBsToastService } from 'ng-bs-toast-service';
import { NgxMaskPipe } from 'ngx-mask';
import { Doctor, DoctorsService } from './';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-doctors',
    standalone: false,
    templateUrl: './doctors.component.html',
})
export class DoctorsComponent implements OnInit {

    loading = { main: true, modal: false };
    doctors: Doctor[];
    currentDoctor: Doctor;
    breadcrumb: Breadcrumb[] = [
        // { title: 'Inicio', route: ['/'] },
        { title: 'Médicos' }
    ]
    filtro = '';

    pagination: FrontPagination = { page: 1, total: 0, pageSize: 10 };

    columns: NgGenerateTableColumns[] = [
        { label: 'Nome', field: 'name' },
        { label: 'Email', field: 'email' },
        { label: 'CRM', field: 'crm' },
        { label: 'Telefone', field: 'phone', pipe: NgxMaskPipe, pipeArgs: ['(00) 00000-0000'] },
        {
            tdClass: 'td-w-auto',
            template: () =>
                `<button type="button" class="btn btn-sm btn-link link-success p-0">
                    <i class="bi bi-pencil-square me-1"></i>Editar
                 </button>`,
            click: (rowData: Doctor) => this.router.navigate(['/doctors/edit', rowData.id])
        }, {
            tdClass: 'td-w-auto',
            template: () =>
                `<button type="button" class="btn btn-sm btn-link link-danger p-0">
                    <i class="bi bi-trash me-1"></i>Apagar
                 </button>`,
            click: (rowData: Doctor) => this.openModal(this.deleteFooter, rowData)
        }
    ]

    @ViewChild('deleteFooter', { static: true }) deleteFooter: TemplateRef<any>;

    constructor(
        private doctorsService: DoctorsService,
        private modalService: NgBsModalService,
        private toastService: NgBsToastService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.getAll()
    }

    getAll(page = 1) {
        this.loading.main = true;
        this.doctorsService.getAll(page).subscribe({
            next: (res) => {this.doctors = res.data; this.pagination = { ...this.pagination, page, total: res.total, pageSize: res.pageSize }},
            error: (err: HttpErrorResponse) => this.toastService.send(`Erro ${err.status}`, err.error.message || err.message, 'danger')
        }).add(() => this.loading.main = false)
    }

    openModal(footer: TemplateRef<any>, doctor: Doctor) {
        this.currentDoctor = doctor;
        this.modalService.open({
            header: 'Apagar Médico',
            body: `Você tem certeza que deseja apagar o médico <strong>${doctor.name}</strong>?`,
            footer
        }, { customClass: { modalHeader: 'bg-danger text-white' } });
    }

    closeModal() {
        this.modalService.close();
    }

    deleteDoctor() {
        this.loading.modal = true;
        this.doctorsService.delete(this.currentDoctor.id).subscribe({
            next: () => {
                this.toastService.send('Sucesso', `Médico ${this.currentDoctor.name} apagado com sucesso`, 'success');
                this.closeModal();
                this.getAll();
            }, error: (err) => this.toastService.send(`Erro ${err.status}`, err.error.message, 'danger')
        }).add(() => this.loading.modal = false);
    }

    filterDoctors(page = 1) {
        this.loading.main = true;
        this.doctorsService.getByTerm(this.filtro, page).subscribe({
            next: (res) => {this.doctors = res.data; this.pagination = { ...this.pagination, page, total: res.total, pageSize: res.pageSize }},
            error: (err: HttpErrorResponse) => this.toastService.send(`Erro ${err.status}`, err.error.message || err.message, 'danger')
        }).add(() => this.loading.main = false);
    }

}
